import { GetCurrentCompanyQuery } from "@/graphql/generated/graphql";
import { GetCurrentCompany } from "@/graphql/queries/GetCurrentCompany";
import { useGraphQuery } from "@dashboard/library";
import { UserCurrentCompanyReturn } from "./useCurrentCompany.decl";

/**
 * Hook to get the current user data.
 * @returns an object holding the query state and user's data
 */
export function useCurrentCompany(): UserCurrentCompanyReturn {
  const { data, loading } =
    useGraphQuery<GetCurrentCompanyQuery>(GetCurrentCompany);

  return {
    loading,
    currentCompany: data?.currentCompany,
  };
}
